import { useAuthContext } from './useAuthContext';

export const useUser = () => {
    const { state } = useAuthContext();
    return state.user;
};
